<h1>Add Spoc Remark <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<div class="row">
    <div class="col-sm-12">
        <form [formGroup]="spokForm" (submit)="createSpok()">
            <div class="row">
                <div class="col-sm-8 right-border">
                    <label class="form-label" >Main Status*</label>
                    <mat-select placeholder="Status" formControlName="status" (selectionChange)="getSpocSubStatus($event.value)">
                        <input class="mySearchInput"
                        #allStatusSearch focused="'true'" type="text"
                        (keyup)="searchOnSelect($event.target.value, 'status')"
                        (keydown)="$event.stopPropagation()" autocomplete="off"
                        placeholder="Search"
                        id="allStatusSearch">
                        <mat-option [value]="data.id" *ngFor="let data of allStatus">{{data.name}}</mat-option>
                        </mat-select>
                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                        <div *ngIf="f.status.errors.required">Status is required</div>
                    </div>
                </div>

                <div class="col-sm-8 right-border mt-2">
                    <label class="form-label" >Sub Status*</label>
                    <mat-select placeholder="Sub Status" formControlName="sub_status" (selectionChange)="addRemoveValidatorOfSpoc($event.value)">
                        <mat-option [value]="subdata.id" *ngFor="let subdata of allSubStatus">{{subdata.name}}</mat-option>
                        </mat-select>
                    <div *ngIf="submitted && f.sub_status.errors" class="invalid-feedback">
                        <div *ngIf="f.sub_status.errors.required">Sub Status is required</div>
                    </div>
                </div>

                <div class="col-sm-8 right-border mt-2" *ngIf="spokForm.controls['sub_status'].value !='9' && spokForm.controls['sub_status'].value !='18' && spokForm.controls['sub_status'].value !='19' && spokForm.controls['sub_status'].value !='20' && spokForm.controls['sub_status'].value !='21' && spokForm.controls['sub_status'].value !='22' && spokForm.controls['sub_status'].value !='23'">
                    <label class="form-label">Followup Date & Time*</label>
                    <input type="datetime-local" formControlName="spoc_followup_datetime" class="form-control" />
                    <div *ngIf="submitted && f.spoc_followup_datetime.errors" class="invalid-feedback">
                        <div *ngIf="f.spoc_followup_datetime.errors.required">Followup Date & Time is required</div>
                    </div>
                </div>

                <div class="col-sm-8 right-border mt-2">
                    <div class="form-group">
                        <label class="form-label">Remark</label>
                        <textarea placeholder="Remark" formControlName="remark" class="form-control"></textarea>
                    </div>
                </div>
            </div>

            <div class="card-footer">
                <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                    class="fa fa-spin fa-spinner"></i> Submit</button>
            </div>
        </form>
    </div>

</div>